import { Component, Injector, OnInit } from '@angular/core';
import 'rxjs/add/operator/finally';
import { UserService } from '../../../../authentication/services/user.service';
import { SelectUserForm } from '../../../../authentication/forms/user/select-user.form';
import { ActiveModal } from '../../../../modals/classes/active-modal';
import { ChassisFormHandler } from '../../../../forms/form/classes/form-handler';

@Component({
    selector: 'chassis-core-tenant-user-create-modal',
    templateUrl: 'create-tenant-user.modal.html',
    styleUrls: ['create-tenant-user.modal.scss']
})
export class CreateTenantUserModal implements OnInit {

    private title = 'Select user';

    /**
     * The Loading instance.
     *
     * @type {any}
     */
    public loading: any;

    /**
     * The ChassisFormHandler instance.
     *
     * @type {ChassisFormHandler}
     */
    public form: ChassisFormHandler;

    /**
     * The object to validate.
     */
    public model: any = {};

    /**
     *
     * @type {UserService}
     */
    protected userService: UserService;

    /**
     * The ActiveModal instance.
     *
     * @type {ActiveModal}
     */
    protected modal: ActiveModal;

    constructor(protected injector: Injector) {
        this.modal       = injector.get(ActiveModal);
        this.userService = injector.get(UserService);
    }

    ngOnInit() {
        this.loading = this.modal.get('loading');

        this.modal.set('title', this.title);

        this.setModalButtons();

        this.createForm();
    }

    private createForm(): void {
        this.form = new ChassisFormHandler(this.injector, SelectUserForm(this.injector), this.model);
    }

    protected setModalButtons() {
        const buttons = this.modal.get<Map<string, any>>('buttons');

        this.setSubmitModalButton(buttons);
    }

    protected setSubmitModalButton(buttons: Map<string, any>) {
        buttons.get('ok').callback = () => {
            return this.submitButtonCallback();
        };
    }

    private submitButtonCallback() {

        const model = this.userService.make(this.model.user);
        this.modal.close(model);

    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/tenants/modals/create-tenant-user/create-tenant-user.modal.ts